<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <InspLoadForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import InspLoadForm from '@/components/organisms/report/form/InspLoadForm'

export default {
  name: 'InspLoadPage',
  components: { InspLoadForm },
}
</script>
